import template from './other-direct-costs-review-details.html';
import controller from './other-direct-costs-review-details.controller';

let otherDirectCostsReviewDetailsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default otherDirectCostsReviewDetailsComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/other-direct-costs-review-details/other-direct-costs-review-details.component.js